import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx';
import { GetModulesResponse } from '../models/modules.model';
import { IndividualPermission, Permissions } from '../enums/permission.enum';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})

export class Helperclass {
  #activeModules = new BehaviorSubject<GetModulesResponse['modulosActivos']>([]);

  activeModules$ = this.#activeModules.asObservable();


  constructor(
    private router: Router,
    private location: Location,
  ) {
  }


  setActiveModules(menu: GetModulesResponse['modulosActivos']) {
    this.#activeModules.next(menu);
  }

  back() {
    this.location.back();
  }

  goRouter(url: string, params = {}): void {
    this.router.navigate([`/${url}`], { queryParams: { ...params } });
  }

  showalert(text: string, html: string, showCancelButton = true): Promise<any> {

    return Swal.fire({
      title: text,
      html: html,
      showCancelButton: showCancelButton,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    });
  }

  dateConverter = (date: string, formate = 'YYYY-MM-DD HH:mm:ss'): string | Date => {
    return dayjs(date).locale('en').format(formate);
  };

  isAdmin() {
    const dataAdmin = JSON.parse(sessionStorage.getItem('dataMotor')!);
    if (dataAdmin.admin === 1) {
      return true;
    } else {
      this.showalert('Error!!', 'No tiene permisos para esta acción', false);
      return false;
    }
  }

  hasPermission(route: string, permission: Permissions): boolean {
    const modules = this.#activeModules.value;
    const getModule = modules.find(module => route.includes(module.patch));
    return !!getModule?.accion.includes(permission);
  }

  hasIndividualPermission(subPermission: IndividualPermission): boolean {
    const modules = this.#activeModules.value;
    const getModule = modules.find(m => m.key.toLowerCase() === 'usuarios agentes');

    if (!getModule) return false;
    return getModule.subactions?.some(s => s === subPermission) || false;
  }


  isAdminAccion() {
    const dataAdmin = JSON.parse(sessionStorage.getItem('dataMotor')!);
    if (dataAdmin.admin === 1) {
      return true;
    } else {

      return false;
    }
  }

  detectarvalorbuscatr(array, item) {
    const index = array.findIndex(cus => cus === item);
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  }

  obtenerObjetosConIds(objetos: any, ids: number[]): any[] {

    return objetos.filter(objeto => ids.includes(objeto.id));
  }
  obtenerObjetosConIdsSepomex(objetos: any, ids: number[]): any[] {
    return objetos.filter(objeto => ids.includes(objeto.id_cat_sepomex));
  }
}
